var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f0f;opacity:0;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "warning") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 96,
    height: 96
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.35,80.88,51.65,11.12c-2-3.92-5.29-3.92-7.3,0L8.65,80.88C6.64,84.8,8.6,88,13,88H83C87.4,88,89.36,84.8,87.35,80.88ZM44,34a4,4,0,0,1,8,0V62a4,4,0,0,1-8,0Zm4,46a5,5,0,1,1,5-5A5,5,0,0,1,48,80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.03584929a9134fbd398f090da3c85cf1.svg";
export { ForwardRef as ReactComponent };